export default class PassCodeActionValidationRequest {
  constructor(obj) {
    if (!obj) obj = {};
    this.actionKey = obj.actionKey ? obj.actionKey : "";
    this.decryptKey = obj.decryptKey ? obj.decryptKey : 0;
    this.accessCode = obj.accessCode ? obj.accessCode : 0;
  }
}
